<template>
  <icon-svg-base
    :view-width="9"
    :view-height="9"
    class="icon"
  >
    <path
      d="M6.7,8C7,8,7.3,8.2,7.3,8.5S7,9,6.7,9H0.8C0.4,9,0,8.6,0,8.1V7.2h0v-5C0,2,0.2,1.7,0.5,1.7C0.8,1.7,1,2,1,2.3v5.2
	C1,7.7,1.3,8,1.6,8h1H6.7z M2.8,6.2h5.2V1H2.8V6.2z M8.4,7.2H2.2C2,7.2,1.7,7,1.7,6.7V0.5C1.7,0.2,2,0,2.2,0h6.2C8.7,0,9,0.2,9,0.5
	v6.2C9,7,8.7,7.2,8.4,7.2z"/>
  </icon-svg-base>
</template>

<script>
import IconSvgBase from '@/mikan/_shared/components/atoms/icons/IconSvgBase.vue';

export default {
  components: {
    IconSvgBase,
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
}
</style>
